export const ReactTableTextProps = {
  loadingText: 'Chargement en cours',
  nextText: 'Suivant',
  noDataText: 'Aucune donnée',
  ofText: 'sur',
  previousText: 'Précédent',
  rowsText: 'lignes',
};